import Article from "./article";

export default function BlogArticle() {
  return <Article />;
}
